import { render, staticRenderFns } from "./DeliveryNoteHistory.vue?vue&type=template&id=4273f9da&lang=pug&"
import script from "./DeliveryNoteHistory.vue?vue&type=script&lang=ts&"
export * from "./DeliveryNoteHistory.vue?vue&type=script&lang=ts&"
import style0 from "./DeliveryNoteHistory.vue?vue&type=style&index=0&id=4273f9da&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports